/**
 * Formatea un número como moneda en formato DOP
 * Usa coma (,) para separar miles y punto (.) para decimales
 * Ejemplo: 5000 -> "DOP 5,000.00"
 *
 * @param {number} value - El valor a formatear
 * @param {boolean} includeDecimals - Si se deben mostrar los decimales (por defecto: false)
 * @returns {string} - El valor formateado
 */
export const formatCurrency = (value, includeDecimals = false) => {
  if (value === null || value === undefined || isNaN(value)) {
    return 'DOP 0';
  }

  const number = parseFloat(value);

  if (includeDecimals) {
    // Formato con decimales: DOP 5,000.50
    return `DOP ${number.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  } else {
    // Formato sin decimales: DOP 5,000
    return `DOP ${Math.round(number).toLocaleString('en-US')}`;
  }
};

/**
 * Formatea un número sin el símbolo de moneda
 * Ejemplo: 5000 -> "5,000"
 *
 * @param {number} value - El valor a formatear
 * @param {boolean} includeDecimals - Si se deben mostrar los decimales (por defecto: false)
 * @returns {string} - El valor formateado
 */
export const formatNumber = (value, includeDecimals = false) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0';
  }

  const number = parseFloat(value);

  if (includeDecimals) {
    return number.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  } else {
    return Math.round(number).toLocaleString('en-US');
  }
};

/**
 * Formatea un porcentaje
 * Ejemplo: 15 -> "15%"
 *
 * @param {number} value - El valor a formatear
 * @returns {string} - El valor formateado
 */
export const formatPercent = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0%';
  }

  const number = parseFloat(value);

  // Si tiene decimales, mostrarlos
  if (number % 1 !== 0) {
    return `${number.toFixed(2)}%`;
  }

  return `${number}%`;
};
